import StaticPage from "layouts/StaticPage"
import React from "react"
const AboutPage = () => (
  <StaticPage>
    <div className="mb-14">
      <p className="mb-4">
        In India, more than 80% of farmers are marginal farmers, having land
        holding of less than 5 acres. This is the prime reason why they are
        unable to purchase resources of their own. The cost of hiring resources
        e.g., transportation services is 12-15% of the total income. Also, most
        of the time the resources are not optimally utilised due to part loading
        and service providers having access to limited set of farmers and vice
        versa.
      </p>

      <p className="mb-4">
        Vesatogo is a{" "}
        <b>platform providing efficient and economical logistics options</b> to
        the marginal farmers of the country and also ensuring{" "}
        <b>optimal utility of resources.</b>
      </p>

      <p className="mb-4">
        Vesatogo is working in association with one of the leading Farmer
        Producer Organisation (FPO) in the country, acting as implementation
        partner. We are privileged to have mentorship and expert guidance from
        industry leaders and domain experts. Vesatogo is based out of Nashik,
        Maharashtra, one of the leading agriculture hubs of the country.
      </p>

      <p>
        Vesatogo is currently being developed for FPOs and their associated
        farmers, helping them in identifying and removing inefficiencies in
        their operations and also saving cost for the farmer. This model once
        developed can be scaled to all the FPOs in the country.
      </p>
    </div>
  </StaticPage>
)

export default AboutPage
